import { render, staticRenderFns } from "./ForbiddenGateway.vue?vue&type=template&id=a0cef214"
import script from "./ForbiddenGateway.vue?vue&type=script&lang=js"
export * from "./ForbiddenGateway.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports